import { render, staticRenderFns } from "./BlogPost.vue?vue&type=template&id=acfa0d6e&scoped=true&"
import script from "./BlogPost.vue?vue&type=script&lang=js&"
export * from "./BlogPost.vue?vue&type=script&lang=js&"
import style0 from "./BlogPost.vue?vue&type=style&index=0&id=acfa0d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfa0d6e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogPostSocialShare: require('/home/circleci/repo/components/blog/BlogPostSocialShare.vue').default,BlogPostImage: require('/home/circleci/repo/components/blog/BlogPostImage.vue').default})
